export const API_URL = {
  /**
   *
   * let currentUrl = window.location.href;
   * let url = '';
   * currentUrl = currentUrl.substring(currentUrl.indexOf("://") + 3);
   * url = currentUrl.substring(0, currentUrl.indexOf("/"));
   *
   * export const SERVER_API_URL = `https://${url}/krbs_api/public/api`
   * export const SERVER_WEB_API_URL = `https://${url}/krbs_api/public`
   *
   *
   */
  index() {
    let currentUrl = window.location.href;
    let url = '';
    currentUrl = currentUrl.substring(currentUrl.indexOf("://") + 3);
    url = currentUrl.substring(0, currentUrl.indexOf("/"));
    return `https://${url}/krbs-tons-api/public/api/tons-v0.0.1/`;
  },
};
export default {API_URL};
